var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, } from "vue-facing-decorator";
import { Action } from "vuex-facing-decorator";
import { MeClient } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import RouteNames from "@/app/router/routes";
const meClient = new MeClient(window.apiUrl);
let TermsOnPremVue = class TermsOnPremVue extends Vue {
    mounted() {
    }
    ;
    accept() {
        meClient
            .acceptTerms()
            .then(response => {
            if (!response)
                return;
            this.setTermsAcceptanceRequirement(false);
            this.$router.push({ name: RouteNames.Home });
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
        });
    }
    ;
};
__decorate([
    Action("setTermsAcceptanceRequirement", { namespace: "loginModule" }),
    __metadata("design:type", Object)
], TermsOnPremVue.prototype, "setTermsAcceptanceRequirement", void 0);
TermsOnPremVue = __decorate([
    Component({
        name: "TermsOnPremVue",
    })
], TermsOnPremVue);
export default TermsOnPremVue;
